import { client } from './client'
import { statusFilterRequest } from './statusFilterRequest'
import type {
  TestPlan, TestPlanFilters, CreateTestPlanRequest, CreateTestPlanResponse, PaginationParams, PagedResult,
  AzureDevOpsProject, AzureDevOpsTestPlan, AzureDevOpsTestSuite, PushTestPlanRequest, PushTestItemsResponse,
} from '@/types'

export const testPlansApi = {
  getByProject: (projectId: string, params?: PaginationParams & TestPlanFilters) =>
    client.get<PagedResult<TestPlan>>(`/projects/${projectId}/test-plans`, statusFilterRequest(params)).then(r => r.data),

  create: (projectId: string, data: CreateTestPlanRequest) =>
    client.post<CreateTestPlanResponse>(`/projects/${projectId}/test-plans`, data).then(r => r.data),

  delete: (projectId: string, testPlanId: string) =>
    client.delete(`/projects/${projectId}/test-plans/${testPlanId}`),

  pushToDevOps: (projectId: string, testPlanId: string, data: PushTestPlanRequest) =>
    client.post<PushTestItemsResponse>(`/projects/${projectId}/test-plans/${testPlanId}/push-to-devops`, data).then(r => r.data),

  getAzureDevOpsProjects: (projectId: string) =>
    client.get<AzureDevOpsProject[]>(`/projects/${projectId}/test-plans/azure-devops/projects`).then(r => r.data),

  getAzureDevOpsPlans: (projectId: string, azureProject: string) =>
    client.get<AzureDevOpsTestPlan[]>(`/projects/${projectId}/test-plans/azure-devops/plans`, { params: { azureProject } }).then(r => r.data),

  getAzureDevOpsSuites: (projectId: string, azureProject: string, azurePlanId: number) =>
    client.get<AzureDevOpsTestSuite[]>(`/projects/${projectId}/test-plans/azure-devops/plans/${azurePlanId}/suites`, { params: { azureProject } }).then(r => r.data),
}
